import { render } from "./master-segment-setting.vue?vue&type=template&id=1f531659&scoped=true"
import script from "./master-segment-setting.vue?vue&type=script&lang=js"
export * from "./master-segment-setting.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css&external"
import "./master-segment-setting.vue?vue&type=style&index=1&id=1f531659&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f531659"]])

export default __exports__